import React, { useState } from 'react'
import style from './header.module.scss'
import { Button, DatePicker, Dropdown, MenuProps, Radio } from 'antd'
import {
  FullscreenExitOutlined,
  FullscreenOutlined,
  HomeOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons'
import { useAppSelector } from '../../starter/hooks/redux'
import { useActions } from '../../starter/hooks/actions'
import { useNavigate, useLocation } from 'react-router-dom'
import dayjs, { Dayjs } from 'dayjs'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const getCurrentForm = (location: any) => {
    if (location.pathname.includes('main')) {
      return 'main'
    }
    if (location.pathname.includes('gantt')) {
      return 'gantt'
    }
    if (location.pathname.includes('settings')) {
      return 'settings'
    }
    if (location.pathname === '/') {
      return 'root'
    }
    return 'main'
  }
  const { isSmall } = useAppSelector((state) => state.viewOptions.main)
  const { zoom, type: ganttType, period } = useAppSelector((state) => state.gantt)
  const { removeUser, setMainIsSmall, setGanttZoom, setGanttType, setIsLoggedIn, setToken } = useActions()

  const { setTmpGanttPeriod } = useActions()

  const [form, setForm] = useState<'main' | 'gantt' | 'root' | 'settings'>(() => getCurrentForm(location))
  function onSignOut(): void {
    setToken('')
    setIsLoggedIn(false)
    removeUser()
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <span
          onClick={() => {
            setForm('settings')
            navigate(`/settings`, { replace: true })
          }}>
          <SettingOutlined />
          <span style={{ marginLeft: '1rem' }}>Настройки</span>
        </span>
      )
    },
    {
      key: '2',
      label: (
        <span onClick={onSignOut}>
          <LogoutOutlined />
          <span style={{ marginLeft: '1rem' }}>Выйти</span>
        </span>
      )
    }
  ]

  const onChangePeriod = (start: Dayjs, end: Dayjs) => {
    setTmpGanttPeriod({ start: start.toDate(), end: end.toDate() })
  }

  return (
    <div className={style.wrapper}>
      <div className={style.left}>
        {form !== 'root' && (
          <div>
            <Radio.Group value={form} onChange={(e) => setForm(e.target.value)}>
              <Radio.Button
                value='main'
                onClick={() => {
                  navigate(`/main`, { replace: true })
                }}>
                Главная
              </Radio.Button>
              <Radio.Button
                value='gantt'
                onClick={() => {
                  navigate(`/gantt`, { replace: true })
                }}>
                Диаграмма активности
              </Radio.Button>
            </Radio.Group>
          </div>
        )}
      </div>
      <div className={style.right}>
        {form === 'gantt' && (
          <>
            <DatePicker.RangePicker
              value={period ? [dayjs(period.start), dayjs(period.end)] : null}
              onChange={(dates) => {
                if (dates && dates[0] && dates[1]) {
                  onChangePeriod(dates[0], dates[1])
                }
              }}
            />
            <div>
              <Radio.Group value={ganttType} onChange={(e) => setGanttType(e.target.value)}>
                <Radio.Button value='project'>Проекты</Radio.Button>
                <Radio.Button value='employee'>Сотрудники</Radio.Button>
              </Radio.Group>
            </div>
            <div>
              <Radio.Group value={zoom} onChange={(e) => setGanttZoom(e.target.value)}>
                <Radio.Button value='Hours'>Часы</Radio.Button>
                <Radio.Button value='Days'>Дни</Radio.Button>
                <Radio.Button value='Months'>Месяцы</Radio.Button>
              </Radio.Group>
            </div>
          </>
        )}
        {(form === 'gantt' || form === 'main') && (
          <div>
            <Button
              className={style.smallButton}
              style={{ visibility: form === 'main' || ganttType === 'project' ? 'visible' : 'hidden' }}
              onClick={() => setMainIsSmall(!isSmall)}
              type={isSmall ? 'primary' : 'dashed'}
              title={'сократить представление'}>
              {isSmall && <FullscreenOutlined className={style.smallIcon} />}
              {!isSmall && <FullscreenExitOutlined className={style.smallIcon} />}
            </Button>
          </div>
        )}
        {form !== 'root' && (
          <Button
            onClick={() => {
              navigate(`/`, { replace: true })
            }}>
            <HomeOutlined />
          </Button>
        )}
        <Dropdown menu={{ items }} placement='bottomRight' trigger={['click']}>
          <Button>
            <UserOutlined />
          </Button>
        </Dropdown>
      </div>
    </div>
  )
}

export default Header
